var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#9DC64E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_711_29550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 17.75L17.75 12.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7083 13.1667C12.9615 13.1667 13.1667 12.9615 13.1667 12.7083C13.1667 12.4552 12.9615 12.25 12.7083 12.25C12.4552 12.25 12.25 12.4552 12.25 12.7083C12.25 12.9615 12.4552 13.1667 12.7083 13.1667Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2913 17.7497C17.5445 17.7497 17.7497 17.5445 17.7497 17.2913C17.7497 17.0382 17.5445 16.833 17.2913 16.833C17.0382 16.833 16.833 17.0382 16.833 17.2913C16.833 17.5445 17.0382 17.7497 17.2913 17.7497Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58376 10.6004C8.58376 10.0656 8.79623 9.55262 9.17442 9.17442C9.55262 8.79623 10.0656 8.58376 10.6004 8.58376H11.5171C12.0496 8.58345 12.5603 8.37256 12.9379 7.99709L13.5796 7.35542C13.767 7.16696 13.9898 7.01739 14.2352 6.91534C14.4806 6.81328 14.7438 6.76074 15.0096 6.76074C15.2754 6.76074 15.5385 6.81328 15.784 6.91534C16.0294 7.01739 16.2522 7.16696 16.4396 7.35542L17.0813 7.99709C17.4588 8.37256 17.9696 8.58345 18.5021 8.58376H19.4188C19.9536 8.58376 20.4666 8.79623 20.8448 9.17442C21.223 9.55262 21.4354 10.0656 21.4354 10.6004V11.5171C21.4357 12.0496 21.6466 12.5603 22.0221 12.9379L22.6638 13.5796C22.8522 13.767 23.0018 13.9898 23.1038 14.2352C23.2059 14.4806 23.2584 14.7438 23.2584 15.0096C23.2584 15.2754 23.2059 15.5385 23.1038 15.784C23.0018 16.0294 22.8522 16.2522 22.6638 16.4396L22.0221 17.0813C21.6466 17.4588 21.4357 17.9696 21.4354 18.5021V19.4188C21.4354 19.9536 21.223 20.4666 20.8448 20.8448C20.4666 21.223 19.9536 21.4354 19.4188 21.4354H18.5021C17.9696 21.4357 17.4588 21.6466 17.0813 22.0221L16.4396 22.6638C16.2522 22.8522 16.0294 23.0018 15.784 23.1038C15.5385 23.2059 15.2754 23.2584 15.0096 23.2584C14.7438 23.2584 14.4806 23.2059 14.2352 23.1038C13.9898 23.0018 13.767 22.8522 13.5796 22.6638L12.9379 22.0221C12.5603 21.6466 12.0496 21.4357 11.5171 21.4354H10.6004C10.0656 21.4354 9.55262 21.223 9.17442 20.8448C8.79623 20.4666 8.58376 19.9536 8.58376 19.4188V18.5021C8.58345 17.9696 8.37256 17.4588 7.99709 17.0813L7.35542 16.4396C7.16696 16.2522 7.01739 16.0294 6.91534 15.784C6.81328 15.5385 6.76074 15.2754 6.76074 15.0096C6.76074 14.7438 6.81328 14.4806 6.91534 14.2352C7.01739 13.9898 7.16696 13.767 7.35542 13.5796L7.99709 12.9379C8.37256 12.5603 8.58345 12.0496 8.58376 11.5171V10.6004Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_711_29550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverage);
export default __webpack_public_path__ + "static/media/Average.c0481c8f344c8f58e16a7b97f2d0daf4.svg";
export { ForwardRef as ReactComponent };